module.exports = __webpack_public_path__ + "img/image52.6e0ff75e.png";